import { all } from 'redux-saga/effects';

import { getSettingsSagaWatcher } from './get_settings.saga';
import { setSettingsSagaWatcher } from './set_settings.saga';



export default function* settingsSaga() {
    yield all([
        getSettingsSagaWatcher(),
        setSettingsSagaWatcher(),
    ]);
}